import { render, staticRenderFns } from "./ShareSubscribePanelMini.vue?vue&type=template&id=b54c99ae&scoped=true&"
import script from "./ShareSubscribePanelMini.vue?vue&type=script&lang=js&"
export * from "./ShareSubscribePanelMini.vue?vue&type=script&lang=js&"
import style0 from "./ShareSubscribePanelMini.vue?vue&type=style&index=0&id=b54c99ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b54c99ae",
  null
  
)

export default component.exports